<template>
  <div id="app" :class="{ 'isPc': !isPc }">
    <Header v-if="header_show" />
    <HeaderMc v-if="header_mc_show" />
    <keep-alive>
      <router-view class="main_warp" v-if="$route.meta.keepAlive" @public_header="public_header"
        @public_footer="public_footer" />
    </keep-alive>
    <router-view class="main_warp" v-if="!$route.meta.keepAlive" @public_header="public_header"
      @public_footer="public_footer" />

    <Footer v-if="footer_show" />
    <FooterMc v-if="footer_mc_show" />
  </div>
</template>
<script>
import Header from '@/components/Header';
import Footer from '@/components/Footer';

import HeaderMc from '@/components/HeaderMc';
import FooterMc from '@/components/FooterMc';
import { isMobile, isPcPath } from "@/assets/js/tools"

export default {
  components: {
    Header,
    Footer,
    HeaderMc,
    FooterMc
  },
  name: 'App',
  data() {
    return {
      header_show: true,
      footer_show: true,
      header_mc_show: false,
      footer_mc_show: false,
      isPc: false
    }
  },
  watch: {
    '$route'(to, from) {
      this.activeIndex = to.path;
      /** 自适应 */
      if (isMobile()) {
        this.header_show = false;
        this.footer_show = false;
        if (this.activeIndex == '/login' || this.activeIndex == '/register'  || this.activeIndex == '/exam-detail') {
          this.header_mc_show = false;
          this.footer_mc_show = false;
        } else {
          this.header_mc_show = true;
          this.footer_mc_show = true;
        }
      } else {
        this.header_mc_show = false;
        this.footer_mc_show = false;
        if (this.activeIndex == '/login' || this.activeIndex == '/register' || this.activeIndex == '/exam-detail') {
          this.header_show = false;
          this.footer_show = false;
        } else {
          this.header_show = true;
          this.footer_show = true;
        }
      }
      /** 纯pc */
      // if (this.activeIndex == '/login') {
      //   this.header_show = false;
      //   this.footer_show = false;
      // } else {
      //   this.header_show = true;
      //   this.footer_show = true;
      // }
    }
  },
  mounted() {
    /** 自适应 */
    if (isMobile()) {
      console.log("=================进来了11")
      this.header_show = false;
      this.footer_show = false;
      this.header_mc_show = true;
      this.footer_mc_show = true;
    } else {
      if (this.$route.path == '/login' || this.$route.path == '/register') {
        console.log("=================进来了22")
        this.header_show = false;
        this.footer_show = false;
      } else {
        this.header_show = true;
        this.footer_show = true;
      }
    }
    this.isPcFun();
    /** 纯pc */
    // if (this.$route.path == '/login') {
    //   console.log("=================进来了22")
    //   this.header_show = false;
    //   this.footer_show = false;
    // } else {
    //   this.header_show = true;
    //   this.footer_show = true;
    // }

  },
  methods: {
    public_header(bool) {
      console.log("进来了===========")
      this.header_show = bool;
    },
    public_footer(bool) {
      this.footer_show = bool;
    },
    isPcFun() {
      this.isPc = isMobile();
    }
  }
}
</script>
<style lang="scss">
@import '@/common.scss';

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #333;
  width: 100%;
  background-color: #f7f7f7;

  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.isPc {
  min-width: 1400px !important;
}

.main_warp {
  flex: 1;
}

nav {
  padding: 30px;
}

nav a {
  font-weight: bold;
  color: #2c3e50;
}

nav a.router-link-exact-active {
  color: #42b983;
}

/* 登录 input */
#loginForm .el-input__inner {
  border: none;
  border-radius: 0;
}

/* 个人中心 右侧标题 */
.center_header {
  width: 100%;
  text-align: left;
  height: 60px;
  border-bottom: 1px solid #f0f0f0;
  padding: 0 34px;
  line-height: 60px;
  font-size: 16px;
  color: #f34343;
}

.clear_form {
  .el-form-item__label {
    width: 100px !important;
    font-size: 14px;
  }

  .el-form-item__content {
    margin-left: 100px !important;
  }

  .el-input__inner {
    height: 40px;
  }

  .el-form-item {
    margin-bottom: 20px;
  }

  .el-button {
    padding: 0;
  }
}

.clear_form_profile {
  .el-form-item__label {
    width: 120px;
    font-size: 14px;
  }
}

.nodata {
  width: 100%;
  min-height: 400px;
  text-align: center;
  line-height: 400px;
  font-size: 18px;
  color: #999999;
}

pre { white-space: pre-wrap!important; word-wrap: break-word!important; }
</style>
